import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=e5101bc4&scoped=true"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&id=e5101bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5101bc4",
  null
  
)

export default component.exports